// src/shared/utils/navigationUtils.js

/**
 * Navigation utilities for handling special navigation cases
 */

/**
 * Smart back navigation that checks if the previous URL is from the same domain
 * If from same domain, uses browser back. If from different domain or no referrer, goes to root.
 */
export function handleSmartBack() {
  const currentDomain = window.location.origin;
  const referrer = document.referrer;
  
  if (referrer && referrer.startsWith(currentDomain)) {
    // Same domain, use normal go back
    window.history.back();
  } else {
    // Different domain or no referrer, go to root
    window.location.href = '/';
  }
}

/**
 * Opens the "Tell me more" page in a new tab
 */
export function handleTellMeMore() {
  window.open('https://maintella.com/intro', '_blank');
}

/**
 * Standard retry handler that reloads the current page
 */
export function handleRetry() {
  window.location.reload();
}
